// Copyright (c) 2016 Deere & Company

import State, {getDefaultState} from '../state';
import searchFilters from '../../shared/reducers/search-filters';

export default (state = getDefaultState().searchFilters, action) => {

    const actionTypes = {
        ...searchFilters
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action, State) :
        state;

};



// WEBPACK FOOTER //
// ./src/product/dealer-recommendations/reducers/search-filters.js